import React from "react";
import { useApp } from "../contexts/AppContext";
import { Landmark, Users, Award, Sparkles } from "lucide-react";

const ABOUT_IMG = "https://images.pexels.com/photos/36631639/pexels-photo-36631639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

const About = () => {
    const { t } = useApp();
    const values = [
        { i: Landmark, l: t.about.v1 },
        { i: Sparkles, l: t.about.v2 },
        { i: Award, l: t.about.v3 },
        { i: Users, l: t.about.v4 },
    ];

    return (
        <div data-testid="page-about" className="container-x section-pad">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div className="fade-up">
                    <div className="chip bg-[hsl(var(--royal))]/10 text-[hsl(var(--royal))] mb-4">{t.nav.about}</div>
                    <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t.about.title}</h1>
                    <p className="mt-4 text-lg text-muted-foreground">{t.about.lead}</p>
                    <p className="mt-6 text-base text-muted-foreground leading-relaxed">{t.about.body1}</p>
                    <p className="mt-4 text-base text-muted-foreground leading-relaxed">{t.about.body2}</p>
                </div>
                <div className="fade-up delay-200">
                    <div className="relative rounded-3xl overflow-hidden shadow-2xl border-4 border-white/40 dark:border-white/10">
                        <img src={ABOUT_IMG} alt="About Sri Matha" className="w-full h-[520px] object-cover" />
                    </div>
                </div>
            </div>

            <div className="mt-20 grid md:grid-cols-2 gap-8">
                <div className="p-8 rounded-3xl border border-border bg-card">
                    <h2 className="text-2xl font-semibold tracking-tight">{t.about.mission}</h2>
                    <p className="mt-3 text-muted-foreground">{t.about.missionDesc}</p>
                </div>
                <div className="p-8 rounded-3xl border border-border bg-card">
                    <h2 className="text-2xl font-semibold tracking-tight">{t.about.values}</h2>
                    <div className="mt-5 grid grid-cols-2 gap-4">
                        {values.map(({ i: Icon, l }, k) => (
                            <div key={k} className="p-4 rounded-2xl bg-muted/60 flex items-center gap-3">
                                <div className="w-10 h-10 rounded-xl bg-[hsl(var(--royal))]/10 text-[hsl(var(--royal))] flex items-center justify-center"><Icon size={18} /></div>
                                <span className="font-semibold">{l}</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default About;
